import Vue from 'vue'
import Vuex from 'vuex'

import { State } from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

// Plugins
import createPersistedState from 'vuex-persistedstate'

// Modules
import { match } from './modules/match/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state: new State(),

  mutations,

  actions,

  getters,

  modules: {
    match,
  },

  plugins: [
    // Persisted state
    createPersistedState({
      paths: [
        // List of paths to persist
        'match.controlsLocked',
      ],
    }),
  ],
})
